import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxMaskModule } from 'ngx-mask';
import { TranslateModule } from '@ngx-translate/core';
import { NgSelectModule } from '@ng-select/ng-select';

import { FormWrapperModule } from '@shared/form-wrapper/form-wrapper.module';
import { DirectivesModule } from '@shared/directives/directives.module';
import { CustomTooltipModule } from '@shared/tooltip/custom-tooltip.module';
import { RequestLoaderModule } from '@shared/request-loader/request-loader.module';
import { NotificationBoxComponent } from '@app/shared/components';

@NgModule({
  declarations: [NotificationBoxComponent],
  imports: [
    FormsModule,
    CommonModule,
    NgxMaskModule,
    NgSelectModule,
    TranslateModule,
    FormWrapperModule,
    ReactiveFormsModule,
    DirectivesModule,
    CustomTooltipModule,
    RequestLoaderModule,
  ],
  exports: [
    FormsModule,
    CommonModule,
    NgxMaskModule,
    NgSelectModule,
    TranslateModule,
    FormWrapperModule,
    ReactiveFormsModule,
    DirectivesModule,
    CustomTooltipModule,
    RequestLoaderModule,

    NotificationBoxComponent,
  ],
  providers: [],
})
export class MutualModule {}
